(function () {
    var typed = '';
    var TRIGGER = 'maktub';
    var birdTimer = null;
    var sandTimer = null;
    var closeBtn = null;
    var horizon = null;

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; startAlch(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/der-alchimist')) {
        // Farbschema sofort, Tiere nach kurzem Delay
        applyDesertTheme();
        setTimeout(startAlch, 600);
    }

    function applyDesertTheme() {
        document.body.classList.add('alch-active');

        horizon = document.createElement('div');
        horizon.className = 'alch-horizon';
        horizon.innerHTML = '<svg viewBox="0 0 1440 180" preserveAspectRatio="none"'
            + ' width="100%" height="180" xmlns="http://www.w3.org/2000/svg">'
            // far dune — muted warm sand
            + '<path d="M0,180 Q200,95 400,130 Q600,165 780,98 Q960,34 1140,90'
            + ' Q1300,138 1440,82 L1440,180 Z" fill="rgba(110,68,22,0.72)"/>'
            // mid dune — richer sand
            + '<path d="M0,180 Q160,128 360,148 Q560,168 760,132'
            + ' Q960,96 1160,128 Q1320,152 1440,118 L1440,180 Z" fill="rgba(148,90,28,0.85)"/>'
            // front dune — warmest, most opaque
            + '<path d="M0,180 Q240,155 480,168 Q720,180 960,155'
            + ' Q1160,134 1440,148 L1440,180 Z" fill="rgba(170,105,32,0.95)"/>'
            + '</svg>';
        document.body.appendChild(horizon);
    }

    function startAlch() {
        if (birdTimer) return;
        document.body.classList.add('alch-active');

        closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.style.cssText = 'position:fixed;top:1rem;right:1.2rem;z-index:10001;';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', stopAlch);
        document.body.appendChild(closeBtn);

        spawnBird();
        scheduleBirds();
        for (var i = 0; i < 18; i++) spawnSand(true);
        scheduleSand();
    }

    function scheduleBirds() {
        birdTimer = setTimeout(function () {
            if (!birdTimer) return;
            spawnBird();
            if (Math.random() < 0.15) setTimeout(spawnBird, 800 + Math.random() * 1200);
            scheduleBirds();
        }, 5500 + Math.random() * 3500);
    }

    function scheduleSand() {
        sandTimer = setTimeout(function () {
            if (!sandTimer) return;
            spawnSand(false);
            scheduleSand();
        }, 120 + Math.random() * 200);
    }

    function stopAlch() {
        clearTimeout(birdTimer); birdTimer = null;
        clearTimeout(sandTimer); sandTimer = null;
        document.body.classList.remove('alch-active');
        document.querySelectorAll('.alch-bird-outer, .alch-sand').forEach(function (el) { el.remove(); });
        if (horizon) { horizon.remove(); horizon = null; }
        if (closeBtn) { closeBtn.remove(); closeBtn = null; }
    }

    function spawnBird() {
        var goLeft  = Math.random() > 0.5;
        var speed   = 10 + Math.random() * 8;
        var w       = Math.round(72 + Math.random() * 48);
        var h       = Math.round(w * 0.38);
        var top     = 5 + Math.random() * 55;
        var soarOff = Math.random() * 3.2;

        var outer = document.createElement('div');
        outer.className = 'alch-bird-outer';
        outer.style.cssText = 'position:fixed;top:' + top + '%;left:0;z-index:9998;pointer-events:none;';

        var carrier = document.createElement('div');
        carrier.className = 'alch-bird-carrier--' + (goLeft ? 'rtl' : 'ltr');
        carrier.style.animationDuration = speed + 's';

        var soar = document.createElement('div');
        soar.className = 'alch-bird-soar';
        soar.style.animationDelay = '-' + soarOff + 's';

        var bird = document.createElement('div');
        if (goLeft) bird.style.transform = 'scaleX(-1)';
        bird.innerHTML = makeBird(w, h);

        soar.appendChild(bird);
        carrier.appendChild(soar);
        outer.appendChild(carrier);
        document.body.appendChild(outer);

        setTimeout(function () { if (outer.parentNode) outer.remove(); }, (speed + 0.5) * 1000);
    }

    function spawnSand(preload) {
        var el = document.createElement('div');
        el.className = 'alch-sand';
        var size  = 0.8 + Math.random() * 2.4;
        var speed = 3.5 + Math.random() * 4.5;
        var top   = 8 + Math.random() * 84;
        var alpha = 0.25 + Math.random() * 0.45;
        var delay = preload ? -(Math.random() * speed) : 0;

        el.style.cssText = 'width:' + size + 'px;height:' + size + 'px;'
            + 'top:' + top + '%;left:-80px;'
            + 'background:rgba(215,175,70,' + alpha + ');'
            + 'animation-duration:' + speed + 's;'
            + 'animation-delay:' + delay + 's;';

        document.body.appendChild(el);
        setTimeout(function () { if (el.parentNode) el.remove(); }, (speed + Math.abs(delay) + 0.5) * 1000);
    }

    function makeBird(w, h) {
        var c  = '#b5893a';
        var cd = '#8a6420';
        return '<svg viewBox="0 0 110 45" width="' + w + '" height="' + h + '"'
            + ' style="filter:drop-shadow(0 1px 3px rgba(140,100,20,0.4))"'
            + ' xmlns="http://www.w3.org/2000/svg">'
            + '<path d="M55,20 C44,15 26,8 4,13 C16,18 32,23 48,25Z" fill="' + c + '"/>'
            + '<path d="M55,20 C66,15 84,8 106,13 C94,18 78,23 62,25Z" fill="' + c + '"/>'
            + '<ellipse cx="55" cy="22" rx="8" ry="5" fill="' + cd + '"/>'
            + '<ellipse cx="64" cy="20" rx="5" ry="4" fill="' + cd + '"/>'
            + '<path d="M68,20 L74,21 L68,22Z" fill="' + cd + '"/>'
            + '<path d="M47,25 L44,37 L50,32 L55,36 L60,32 L63,37 L60,25" fill="' + cd + '"/>'
            + '</svg>';
    }
})();
